import { useRef } from 'react';
export function useFirstMountState() {
    var isFirst = useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useFirstMountState.js
// module id = Cq+j
// module chunks = 0